import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  header: (open: boolean) => ({
    px: '16px',
    py: '12px',
    cursor: 'pointer',
    ...(open ? { backgroundColor: 'primary.main', color: 'var(--white)' } : {})
  } satisfies SxProps<Theme>),
  name: (open: boolean) => ({
    flexGrow: 1,
    fontWeight: open ? 700 : 500
  } satisfies SxProps<Theme>),
  progressRow: {
    minWidth: 220
  } satisfies SxProps<Theme>,
  progressBar: (onDark: boolean, complete: boolean) => ({
    flexGrow: 1,
    height: 8,
    borderRadius: 4,
    backgroundColor: onDark ? 'rgba(255,255,255,0.35)' : 'var(--grey-300)',
    '& .MuiLinearProgress-bar': {
      backgroundColor: onDark ? 'var(--white)' : (complete ? 'secondary.main' : 'primary.main'),
      borderRadius: 4
    }
  } satisfies SxProps<Theme>),
  progressValue: (onDark: boolean) => ({
    width: 42,
    textAlign: 'right',
    color: onDark ? 'var(--white)' : 'text.secondary'
  } satisfies SxProps<Theme>),
  expand: (onDark: boolean) => ({
    width: 28,
    height: 28,
    ...(onDark
      ? { backgroundColor: 'var(--white)', color: 'primary.main', '&:hover': { backgroundColor: 'var(--white)' } }
      : { backgroundColor: 'primary.main', color: 'var(--white)', '&:hover': { backgroundColor: 'primary.dark' } })
  } satisfies SxProps<Theme>)
}
